import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { mutations } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { computed, onMounted, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { addSuccessToast } from "@/vue-service";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'CopySettingModal',
  props: {
    user: null,
    value: { type: Boolean },
    users: null
  },
  emits: ['input', 'submit'],
  setup(__props: any, { emit }) {

const props = __props as { user: User, value: boolean, users: User[] };

const form = ref(getDefaultForm());



const { $t } = useTranslation();


onMounted(() => {
  form.value = getDefaultForm();
})

const usersSameRoleAndWithoutSelf = computed(() => {
  return props.users.filter(user => user.userId !== props.user.userId).filter(user => user.roleName === props.user.roleName);
})


function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    profileTargetUserIds: [],
    ddTargetUserIds: [],
    ttTargetUserIds: [],
  });
}

function resetForm() {
  form.value = getDefaultForm();
}

watch(() => (props.user), () => {
  resetForm();
})

async function handleSubmit() {
  try {
    const result = await apolloClient.mutate({
      mutation: mutations.copySetting,
      variables: {
        payload: {
          referenceUserId: props.user.userId,
          profileTargetUserIds: form.value.profileTargetUserIds,
          ddTargetUserIds: form.value.ddTargetUserIds,
          ttTargetUserIds: form.value.ttTargetUserIds,
        }
      }
    });
    addSuccessToast("Settings copied successfully");
    resetForm();
    emit("submit");
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
}


return { __sfc: true,form, props, emit, $t, usersSameRoleAndWithoutSelf, toggleModal, getDefaultForm, resetForm, handleSubmit }
}

})